export const churchInfo = {
  name: "True Love Missionary Baptist Church",
  tagline: "Keep on loving each other as brothers and sisters. - Hebrews 13:1",
  pastor: "Pastor Carlous Parker",
  address: "100 E 119th St",
  city: "Los Angeles, CA 90061",
  facebook: "https://www.facebook.com/profile.php?id=61568665376015",
  youtube: "https://www.youtube.com/@carlousparkerministries8566",
  email: "trueloveis1@att.net"
};

export const services = [
  {
    id: 1,
    name: "Sunday Service",
    time: "11:00 AM",
    day: "Sunday",
    description: "Join us for worship, praise, and powerful preaching"
  },
  {
    id: 2,
    name: "Choir Rehearsal",
    time: "10:00 AM",
    day: "Sunday",
    description: "Prepare your voice to praise the Lord"
  },
  {
    id: 3,
    name: "Bible Study",
    time: "7:00 PM",
    day: "Wednesday",
    description: "Bible study resuming April 15th via Zoom.",
    zoomLink: "https://us05web.zoom.us/j/81120587177"
  }
];

export const ministries = [
  {
    id: 2,
    name: "Deacon Board",
    description: "The Deacon Board provides spiritual leadership and support to our congregation, assisting the Pastor in ministry and serving the needs of our church family.",
    icon: "Heart"
  },
  {
    id: 4,
    name: "Mission Department",
    description: "The Mission Department reaches out to our community and beyond, spreading the Gospel and showing Christ's love through service and outreach programs.",
    icon: "Globe"
  },
  {
    id: 3,
    name: "Mother's Board",
    description: "Our Mother's Board consists of wise and faithful women who provide guidance, prayer support, and nurturing care to all members of our church community.",
    icon: "Home"
  },
  {
    id: 7,
    name: "Music Ministry",
    description: "Led by Rev. Bobbi Lee Anderson and accompanied by Bro. Cliff, our Music Ministry lifts the congregation in praise and worship through song, preparing hearts to receive the Word of God.",
    icon: "Music",
    link: "/music"
  },
  {
    id: 5,
    name: "Pastor's Aid Department",
    description: "This dedicated group supports Pastor Parker in his ministry, providing assistance and ensuring he has what he needs to shepherd our congregation effectively.",
    icon: "HandHeart"
  },
  {
    id: 8,
    name: "Prayer Ministry",
    description: "Our Prayer Ministry is dedicated to lifting up the needs of our congregation and community. Join us for prayer requests and testimonies as we believe God together for breakthroughs and answered prayers.",
    icon: "Heart",
    link: "/prayer"
  },
  {
    id: 1,
    name: "Usher Board",
    description: "Our Usher Board serves as the welcoming face of our church, greeting members and visitors with warm smiles and ensuring everyone feels at home in God's house.",
    icon: "Users"
  },
  {
    id: 6,
    name: "Youth & Young Adult Department",
    description: "We nurture the next generation through Bible study, fellowship, and activities designed to help young people grow in their faith and relationship with Christ.",
    icon: "Sparkles"
  }
];

export const salvationSteps = [
  {
    id: 1,
    title: "Confess",
    scripture: "Romans 10:9",
    verse: "That if thou shalt confess with thy mouth the Lord Jesus, and shalt believe in thine heart that God hath raised him from the dead, thou shalt be saved.",
    description: "Confess with your mouth that Jesus is Lord"
  },
  {
    id: 2,
    title: "Believe",
    scripture: "John 3:16",
    verse: "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.",
    description: "Believe in your heart that God raised Jesus from the dead"
  },
  {
    id: 3,
    title: "Repent",
    scripture: "Acts 3:19",
    verse: "Repent ye therefore, and be converted, that your sins may be blotted out, when the times of refreshing shall come from the presence of the Lord.",
    description: "Turn away from sin and toward God"
  }
];

export const sinMessage = {
  title: "Understanding Sin",
  content: "Everybody sins. Even church people. No one is perfect. The goal is to sin less, not be sinless. That is impossible. Only sinners can receive salvation. If you would like to receive this salvation, you don't need a church, you don't need a pastor, you don't need to pay anyone any money. Simply pray this prayer and believe in your heart, and the Holy Spirit will do the rest of the work."
};

export const sinnersPrayer = {
  title: "The Sinner's Prayer",
  prayer: "Dear Lord Jesus, I know that I am a sinner, and I ask for Your forgiveness. I believe You died for my sins and rose from the dead. I turn from my sins and invite You to come into my heart and life. I want to trust and follow You as my Lord and Savior. In Your Name, Amen."
};

export const fruitsOfSpirit = {
  title: "The Fruits of the Spirit",
  intro: "The greatest commandment is love. You will know who is a true follower of Jesus based on these fruits being shown:",
  scripture: "Galatians 5:22-23",
  fruits: [
    "Love",
    "Joy",
    "Peace",
    "Longsuffering (Patience)",
    "Gentleness",
    "Goodness",
    "Faith",
    "Meekness",
    "Temperance (Self-control)"
  ]
};

export const tenCommandments = {
  title: "The Ten Commandments",
  intro: "The greatest commandment is love since Christ has died in our place. Since we are called to be living sacrifices that live holy and acceptable lives, here are 10 commandments that God gave the Israelites that we can apply to our own lives:",
  commandments: [
    "Thou shalt have no other gods before me.",
    "Thou shalt not make unto thee any graven image.",
    "Thou shalt not take the name of the LORD thy God in vain.",
    "Remember the sabbath day, to keep it holy.",
    "Honour thy father and thy mother.",
    "Thou shalt not kill.",
    "Thou shalt not commit adultery.",
    "Thou shalt not steal.",
    "Thou shalt not bear false witness against thy neighbour.",
    "Thou shalt not covet."
  ]
};

export const baptistBeliefs = salvationSteps; // Keep for backward compatibility

export const aboutContent = {
  mission: "At True Love Missionary Baptist Church, we are committed to spreading the Gospel of Jesus Christ, nurturing spiritual growth, and serving our community with love and compassion. We believe in creating a church family where everyone is welcomed, loved, and encouraged to grow in their faith.",
  vision: "To be a beacon of hope and love in our community, transforming lives through the power of Jesus Christ and demonstrating God's love through our words and actions.",
  history: "True Love Missionary Baptist Church has been a cornerstone of faith in Los Angeles for years, providing spiritual guidance and community support. Under the leadership of Pastor Carlous Parker, we continue to grow as a church family united in brotherly love and service to God.",
  visitMessage: "Come worship with us at 11AM every Sunday. We are located at the intersection of Main and 119th Street in South Los Angeles."
};